export default {"src":"/_next/static/media/cloak.0e0c7885.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};